<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> Comment Review </h5>
     <br/>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="Read_Comments()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Description</th>
              <th>Registered By</th>
              <th>Registration Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Comment
            | paginate
                    : {
                        id: 'DataList_Comment',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Comment).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Comment.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.username}} </td>
              <td>{{item.persianDate}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal_Edit(templateEdit,item)"><i class="fa fa-edit"></i> Edit </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,1)"><i class="fa fa-check"></i> Approve Comment </a>
                        <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item,-1)"><i class="fa  fa-times"></i> Reject Comment </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Comment"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>



<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Operation==1"  class="modal-title pull-left">Approve Submitted Comment </h4>
    <h4 *ngIf="Operation==-1" class="modal-title pull-left">Reject Submitted Comment  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Operation.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="card-body" *ngIf="Operation==1" >

    <div class="row">
      <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Priority  </label>
          <select [(ngModel)]="Priority" class="custom-select">
            <option value="0">Normal</option>
            <option value="1">Important</option>
            <option value="2">Critical</option>
          </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Operation==1"  type="button" class="btn btn-warning" (click)="OnOperation()"> Approve Comment <i class="fa fa-check"></i></button>
    <button *ngIf="Operation==-1" type="button" class="btn btn-warning" (click)="OnOperation()"> Reject Comment <i class="fa fa-times"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Operation.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Edit Customer Comment '{{Data_Seleted_Comment.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="EditDsc"  name="EditDsc" type="text" class="form-control"  placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="Edit()"> Edit <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">Close</button>
  </div>
</ng-template>
